var _g, _g2, _g3, _path, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSonicCustomizationFeature06(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 293,
    height: 182,
    viewBox: "0 0 293 182",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_2046_54079)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48 17C48 10.3726 53.3726 5 60 5H233C239.627 5 245 10.3726 245 17V136C245 142.627 239.627 148 233 148H60C53.3726 148 48 142.627 48 136V17Z",
    fill: "url(#paint0_linear_2046_54079)",
    fillOpacity: 0.4
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_2046_54079)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 148,
    width: 253,
    height: 10,
    rx: 5,
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_2046_54079)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M156.23 19.1538C156.23 15.7552 158.986 13 162.384 13H230.846C234.245 13 237 15.7552 237 19.1538V66.8462C237 70.2448 234.245 73 230.846 73H162.384C158.986 73 156.23 70.2448 156.23 66.8462V19.1538Z",
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M196.614 61.0128C196.614 61.0128 210.717 53.9615 210.717 43.3846V31.0448L196.614 25.7563L182.512 31.0448V43.3846C182.512 53.9615 196.614 61.0128 196.614 61.0128Z",
    stroke: "black",
    strokeWidth: 3.46154,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 63,
    y: 58.6571,
    width: 53.5702,
    height: 10.608,
    rx: 5.30398,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 63,
    y: 96.3143,
    width: 53.5702,
    height: 10.608,
    rx: 5.30398,
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 63,
    y: 72.447,
    width: 53.5702,
    height: 3.71279,
    rx: 1.85639,
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 63,
    y: 78.2814,
    width: 77.4358,
    height: 3.71267,
    rx: 1.85634,
    fill: "white"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 63,
    y: 84.1155,
    width: 36.5975,
    height: 3.71279,
    rx: 1.85639,
    fill: "white"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 63,
    y: 21,
    width: 53.5702,
    height: 10.608,
    rx: 5.30398,
    fill: "white"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 63,
    y: 34.7903,
    width: 53.5702,
    height: 3.71279,
    rx: 1.85639,
    fill: "white"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 63,
    y: 40.6246,
    width: 77.4358,
    height: 3.71267,
    rx: 1.85634,
    fill: "white"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 63,
    y: 46.4587,
    width: 36.5975,
    height: 3.71279,
    rx: 1.85639,
    fill: "white"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 63,
    y: 110.104,
    width: 53.5702,
    height: 3.71279,
    rx: 1.85639,
    fill: "white"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 63,
    y: 115.938,
    width: 77.4358,
    height: 3.71267,
    rx: 1.85634,
    fill: "white"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 63,
    y: 121.773,
    width: 36.5975,
    height: 3.71279,
    rx: 1.85639,
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_2046_54079",
    x: 44,
    y: 1,
    width: 205,
    height: 151,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_2046_54079"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_2046_54079",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_2046_54079",
    x: 0,
    y: 132,
    width: 293,
    height: 50,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2046_54079"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2046_54079",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_2046_54079",
    x: 140.846,
    y: 0.692307,
    width: 111.539,
    height: 90.7692,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.07692
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.69231
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2046_54079"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2046_54079",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2046_54079",
    x1: 146.5,
    y1: 5,
    x2: 146.5,
    y2: 148,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3866C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3866C2",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSonicCustomizationFeature06);
export default __webpack_public_path__ + "static/media/sonic-customization-feature-06.7d72f403d5bb0725546e5bb1cb330b11.svg";
export { ForwardRef as ReactComponent };